.specification-interval-simple-field__container {
  & .ant-select-selector {
    padding: 4px 8px !important;
  }

  & .text-input__container, .control-wrapper {
    padding: 0;
  }

  & .validation-error__container {
    margin-top: -2px;
  }

  padding: 8px 0; // according to control-wrapper
}

// Taken from text-input__label
.specification-interval-simple-field__container .specification-interval-simple-field__label {
  text-align: left;
  font-weight: 500;
  white-space: nowrap;
}

// Taken from text-input__description
.specification-interval-simple-field__container .specification-interval-simple-field__description {
  color: #555768;

  font-weight: 500;
  text-align: left;

  white-space: pre-wrap;
}
